import { FlowErrorType } from './error'
import { UploadedFileType } from './files'

export enum CustomerEligibilityOptions {
  ALL_CUSTOMERS = 'ALL_CUSTOMERS',
  FIRST_TIME_CUSTOMERS = 'FIRST_TIME_CUSTOMERS',
  SPECIFIC_CUSTOMERS = 'SPECIFIC_CUSTOMERS',
  LIFETIME_ORDER_COUNT = 'LIFETIME_ORDER_COUNT',
  CUSTOMER_SEGMENT = 'CUSTOMER_SEGMENT',
  UTM_PARAMS = 'UTM_PARAMS',
  PINCODE_RTO_RISK = 'PINCODE_RTO_RISK',
  CUSTOMER_RTO_RISK = 'CUSTOMER_RTO_RISK',
  ORDER_RATE_LIMIT = 'ORDER_RATE_LIMIT',
  SPECIFIC_PINCODES = 'SPECIFIC_PINCODES'
}

export enum RtoRiskStrategyOptions {
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN'
}

export type CustomerEligibilityStateType =
  | {
      type: CustomerEligibilityOptions.ALL_CUSTOMERS
    }
  | {
      type: CustomerEligibilityOptions.FIRST_TIME_CUSTOMERS
    }
  | {
      type: CustomerEligibilityOptions.LIFETIME_ORDER_COUNT
      minimumOrders: number
      maximumOrders: number | null
    }
  | {
      type: CustomerEligibilityOptions.CUSTOMER_SEGMENT
      segmentIds: string[]
    }
  | {
      type: CustomerEligibilityOptions.SPECIFIC_CUSTOMERS
      uploadedFile: UploadedFileType
      formData?: FormData
    }
  | {
      type: CustomerEligibilityOptions.SPECIFIC_PINCODES
      uploadedFile: UploadedFileType
      formData?: FormData
    }
  | {
      type: CustomerEligibilityOptions.UTM_PARAMS
      utmData: Record<string, string[]>
    }
  | {
      type: CustomerEligibilityOptions.PINCODE_RTO_RISK
      strategy: RtoRiskStrategyOptions
      score: number | ''
    }
  | {
      type: CustomerEligibilityOptions.CUSTOMER_RTO_RISK
      strategy: RtoRiskStrategyOptions
      score: number | ''
    }
  | {
      type: CustomerEligibilityOptions.ORDER_RATE_LIMIT
      paymentMethod: string
      maxOrders: number
      timePeriod: number
    }
  | {
      type: CustomerEligibilityOptions.SPECIFIC_CUSTOMERS
      uploadedFile?: UploadedFileType
      formData?: FormData
    }
  | {
      type: CustomerEligibilityOptions.SPECIFIC_PINCODES
      uploadedFile?: UploadedFileType
      formData?: FormData
    }

export enum utmDataOptions {
  UTM_SOURCE = 'UTM_SOURCE',
  UTM_CAMPAIGN = 'UTM_CAMPAIGN',
  UTM_MEDIUM = 'UTM_MEDIUM',
  UTM_CONTENT = 'UTM_CONTENT'
}

export type UTMSelectorStateType = {
  key: utmDataOptions
  value: string[]
}

export type UTMSelectorDropdownOptionType = {
  label: string
  value: utmDataOptions
}

export type ActivePeriodStateType = {
  startDate: Date
  endDate?: Date
  endDateEnabled: boolean
}

export type CustomerEligibilityErrorStateType =
  | {
      type: CustomerEligibilityOptions.LIFETIME_ORDER_COUNT
      minimumOrders: FlowErrorType
      maximumOrders: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.SPECIFIC_CUSTOMERS
      uploadedFile: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.CUSTOMER_SEGMENT
      segmentIds: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.SPECIFIC_PINCODES
      uploadedFile: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.UTM_PARAMS
      utmData: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.PINCODE_RTO_RISK
      score: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.CUSTOMER_RTO_RISK
      score: FlowErrorType
    }

export type ActivePeriodErrorStateType = {
  startDate: FlowErrorType
  endDate: FlowErrorType
}

export type CustomerEligibilityErrorType = {
  minimumOrders?: FlowErrorType
  maximumOrders?: FlowErrorType
  segmentIds?: FlowErrorType
  utmData?: FlowErrorType
  score?: FlowErrorType
  paymentMethod?: FlowErrorType
  maxOrders?: FlowErrorType
  timePeriod?: FlowErrorType
  uploadedFile?: FlowErrorType
  fileMeta?: FlowErrorType
}

export interface Segment {
  id: string
  name: string
  metadata?: {
    file_meta?: {
      count?: number
    }
  }
}

export interface SegmentListResponse {
  data: {
    data: Segment[]
  }
}

export interface SegmentUIOption {
  value: string
  label: string
  customerCount: number
}

export interface CustomerSegmentsProps {
  state: Extract<CustomerEligibilityStateType, { type: CustomerEligibilityOptions.CUSTOMER_SEGMENT }>
  onChange: (value: CustomerEligibilityStateType) => void
  error?: FlowErrorType
}

export interface DiscountRaw {
  coupon_id: string
  code: string
  title: string
  active: boolean
  auto_applicable: boolean
}

export interface DiscountListResponse {
  data: DiscountRaw[]
  total_count: number
  max_pages: number
  success: boolean
}

export interface DiscountMetadata {
  [coupon_id: string]: DiscountRaw
}

export interface CouponSummary {
  coupon_id: string
  code: string
  title?: string
  header?: string
  description?: string
  long_description?: string
}

export interface CouponSummaryResponse {
  message: string
  data: CouponSummary[]
}

export interface GenericDiscountSelectorProps {
  selectedIds: string[]
  onChange: (selectedIds: string[]) => void
  error?: string
}
